import React from 'react';
import { Controller, Control, FieldErrors } from 'react-hook-form';
import { TextField } from '@material-ui/core';
import { ChallengeFormData } from '../types';

interface BasicInfoStepProps {
  control: Control<ChallengeFormData>;
  errors: FieldErrors<ChallengeFormData>;
}

const BasicInfoStep = ({ control, errors }: BasicInfoStepProps) => {
  const fields = [
    {
      name: 'title' as keyof ChallengeFormData,
      label: 'Challenge Title *',
      helperText: 'Max. 100 characters',
      required: true,
      maxLength: 100,
    },
  ];

  return (
    <div>
      {fields.map((field, index) => (
        <Controller
          key={field.name}
          name={field.name}
          control={control}
          rules={{
            required: field.required ? `${field.label?.replace(' *', '')} is required` : false,
            maxLength: field.maxLength
              ? {
                  value: field.maxLength,
                  message: `Maximum ${field.maxLength} characters allowed`,
                }
              : undefined,
          }}
          render={({ field: controllerField }) => (
            <TextField
              {...controllerField}
              label={field.label}
              fullWidth
              multiline={field.multiline}
              rows={field.multiline ? 4 : 1}
              variant="outlined"
              error={!!errors[field.name]}
              helperText={errors[field.name]?.message || field.helperText}
              style={index < fields.length - 1 ? { marginBottom: '20px' } : undefined}
            />
          )}
        />
      ))}
    </div>
  );
};

export default BasicInfoStep;
